;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('FilterSidebarService', FilterSidebarService)

  FilterSidebarService.$inject = ['PreferencesService']

  /**
   * Constructor
   */
  function FilterSidebarService (PreferencesService) {
    var self = this

    var filterVisible
    var colVisible
    var dataVisible
    var criteriaVisible

    _.extend(self, {
      // Public Attributes
      filterVisible: filterVisible,
      colVisible: colVisible,
      dataVisible: dataVisible,
      criteriaVisible: criteriaVisible,

      // Public Methods
      init: init,
      toggleFilters: toggleFilters,
      toggleColumns: toggleColumns,
      toggleDataSelection: toggleDataSelection,
      toggleCriteriaSelection: toggleCriteriaSelection
    })

    /**
     * Display or hide the sidebar
     */
    function init () {
      PreferencesService.getPrefsFor('general').then(function (prefs) {
        self.prefs = prefs
        self.filterVisible = (prefs.settings && prefs.settings.hasOwnProperty('sideBarVisible')) ? prefs.settings.sideBarVisible : false
        self.colVisible = false
        self.dataVisible = false
        self.criteriaVisible = false
      })
    }

    function toggleFilters () {
      self.filterVisible = !self.filterVisible
      self.colVisible = false
      self.dataVisible = false
      self.criteriaVisible = false
      if (self.prefs.settings) {
        self.prefs.settings.sideBarVisible = isSideBarVisible()
        self.prefs.save()
      }
    }

    function toggleColumns () {
      self.colVisible = !self.colVisible
      self.filterVisible = false
      self.dataVisible = false
      self.criteriaVisible = false
      if (self.prefs.settings) {
        self.prefs.settings.sideBarVisible = isSideBarVisible()
        self.prefs.save()
      }
    }

    function toggleDataSelection () {
      self.dataVisible = !self.dataVisible
      self.filterVisible = false
      self.colVisible = false
      self.criteriaVisible = false
      if (self.prefs.settings) {
        self.prefs.settings.sideBarVisible = isSideBarVisible()
        self.prefs.save()
      }
    }

    function toggleCriteriaSelection () {
      self.criteriaVisible = !self.criteriaVisible
      self.filterVisible = false
      self.colVisible = false
      self.dataVisible = false
      if (self.prefs.settings) {
        self.prefs.settings.sideBarVisible = isSideBarVisible()
        self.prefs.save()
      }
    }

    function isSideBarVisible () {
      return self.dataVisible || self.colVisible || self.filterVisible || self.criteriaVisible
    }
  }
})(window.angular, window._)
